import { Link } from "react-router-dom";
import React from "react";
import "../styles/InternshipTraining.css";
import in1 from "../assets/services/internship 2.jpeg";
import in2 from "../assets/services/internship1.jpeg";

const solutions = [
  {
    title: "Technical Internships",
    description:
      "Gain practical exposure to software, web development and technology projects through structured internship programs.",
  },
  {
    title: "UI/UX Training",
    description:
      "Learn user interface and user experience fundamentals through practical design exercises and project-based learning.",
  },
  {
    title: "Full Stack Development",
    description:
      "Build practical knowledge of frontend, backend, databases and APIs through hands-on development projects.",
  },
  {
    title: "AI & Emerging Technology",
    description:
      "Explore modern technology concepts and practical tools through guided learning and project activities.",
  },
  {
    title: "Project Based Learning",
    description:
      "Work on practical projects that help learners understand how concepts are applied in real development environments.",
  },
  {
    title: "Career Preparation",
    description:
      "Develop technical, communication and interview skills to prepare for opportunities in the technology industry.",
  },
];

const process = [
  {
    title: "Learn",
    description:
      "Understand important concepts through structured lessons and practical guidance.",
  },
  {
    title: "Practice",
    description:
      "Apply what you learn through exercises, tools and hands-on activities.",
  },
  {
    title: "Build",
    description:
      "Create practical projects that demonstrate your skills and understanding.",
  },
  {
    title: "Grow",
    description:
      "Improve your portfolio, confidence and career readiness through continuous learning.",
  },
];

function InternshipTraining() {
  return (
    <main className="training-page">

      <section className="training-hero">
        <div className="training-hero-content">
          <span className="training-eyebrow">
            INTERNSHIP & TRAINING
          </span>

          <h1>
            Learn Skills
            <span> Build Your Future</span>
          </h1>

          <p>
            Develop practical technology skills through
            structured training, internships and project-based
            learning designed for career growth.
          </p>

          <a href="#training-solutions" className="training-primary-btn">
            Explore Training
            <span>→</span>
          </a>
        </div>

        <div className="training-hero-visual">
          <div className="training-hero-image">
            <img
              src={in1}
              alt="Students learning technology"
            />
          </div>
        </div>
      </section>

      <section className="training-intro">
        <div className="training-intro-header">
          <div className="training-intro-label">
            <span>01</span>
            <p>WHAT WE TEACH</p>
          </div>

          <div className="training-intro-heading">
            <h2>
              Practical learning for
              <span> real career opportunities</span>
            </h2>

            <p>
              Our training and internship programs combine
              concepts, practical exercises and project work to
              help learners build useful technology skills.
            </p>
          </div>
        </div>

        <div className="training-intro-content">
          <div className="training-intro-main">
            <span>OUR APPROACH</span>

            <h3>
              Learning becomes valuable when you
              <strong> actually build something</strong>
            </h3>

            <p>
              We focus on practical learning that helps students
              understand concepts, use modern tools and develop
              projects they can confidently present.
            </p>
          </div>

          <div className="training-intro-points">
            <div className="training-intro-point">
              <span>01</span>
              <div>
                <h4>Practical skills</h4>
                <p>
                  Learn through exercises, tools and real project
                  activities instead of theory alone.
                </p>
              </div>
            </div>

            <div className="training-intro-point">
              <span>02</span>
              <div>
                <h4>Project experience</h4>
                <p>
                  Build projects that demonstrate your learning
                  and help strengthen your portfolio.
                </p>
              </div>
            </div>

            <div className="training-intro-point">
              <span>03</span>
              <div>
                <h4>Career readiness</h4>
                <p>
                  Improve technical confidence, communication
                  and preparation for future opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="training-solutions"
        id="training-solutions"
      >
        <div className="training-section-heading">
          <div>
            <span className="training-small-label">
              LEARNING PROGRAMS
            </span>

            <h2>
              Explore our
              <span> training programs</span>
            </h2>
          </div>

          <p>
            Practical learning experiences designed to help
            students develop skills and prepare for careers.
          </p>
        </div>

        <div className="training-solutions-grid">
          {solutions.map((item) => (
            <article
              className="training-solution-card"
              key={item.title}
            >
              <div className="training-card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="training-tech-section">
        <div className="training-tech-content">
          <span className="training-small-label">
            LEARN BY BUILDING
          </span>

          <h2>
            Turn knowledge
            <span> into practical skills</span>
          </h2>

          <p>
            The best way to understand technology is to use it.
            Our learning approach encourages students to practice,
            experiment and build projects.
          </p>

          <div className="training-tech-points">
            <div>
              <strong>01</strong>
              <h4>Hands-on learning</h4>
              <p>
                Practice technology concepts through guided
                exercises and practical activities.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h4>Portfolio projects</h4>
              <p>
                Build projects that demonstrate your skills
                to recruiters and potential employers.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h4>Career confidence</h4>
              <p>
                Improve your ability to explain and demonstrate
                the skills you have developed.
              </p>
            </div>
          </div>
        </div>

        <div className="training-tech-visual">
          <div className="training-tech-image">
            <img
              src={in2}
              alt="Technology training"
            />
          </div>
        </div>
      </section>

      <section className="training-process">
        <div className="training-process-heading">
          <span className="training-small-label">
            HOW WE LEARN
          </span>

          <h2>
            Learn.
            <span> Practice. Build. Grow.</span>
          </h2>

          <p>
            A simple learning process helps students move from
            understanding concepts to creating practical projects.
          </p>
        </div>

        <div className="training-process-grid">
          {process.map((item, index) => (
            <article
              className="training-process-item"
              key={item.title}
            >
              <div className="training-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="training-final">
        <div className="training-final-content">
          <div className="training-final-main">
            <div className="training-final-label">
              <span></span>
              START YOUR LEARNING JOURNEY
            </div>

            <h2>
              Learn today
              <span> Build tomorrow</span>
            </h2>

            <p>
              Tell us what skill you want to learn or what kind
              of internship you are looking for. We can help you
              explore the available opportunities.
            </p>
          </div>

          <div className="training-final-action">
            <div className="training-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>
              <p>Learn · Build · Grow</p>
            </div>

            <Link
              to="/contact"
              className="training-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default InternshipTraining;